module.exports = __webpack_public_path__ + "resources/images/mappen-0e1505496c442a401c501fb0b41edf18-cache.jpg";